import { RSAA, getJSON } from "redux-api-middleware";

import { OAUTH_SERVER, GRANT_TYPE, CLIENT_ID, CLIENT_SECRET, REDIRECT_URL, SCOPE } from "../../constants/constants";

export const OAUTH_SET_RANDOM_STATE = "OAUTH_SET_RANDOM_STATE";
export const OAUTH_SET_DATA = "OAUTH_SET_DATA";
export const OAUTH_SET_NOTIFICATION_PERMISSION = "OAUTH_SET_NOTIFICATION_PERMISSION";

export const OAUTH_TOKEN_REQUEST = "OAUTH_TOKEN_REQUEST";
export const OAUTH_REFRESH_SUCCESS = "OAUTH_REFRESH_SUCCESS";
export const OAUTH_TOKEN_SUCCESS = "OAUTH_TOKEN_SUCCESS";
export const OAUTH_TOKEN_FAILURE = "OAUTH_TOKEN_FAILURE";
export const OAUTH_TOKEN_REFRESH_FAILURE = "OAUTH_TOKEN_REFRESH_FAILURE";

export const OAUTH_LOGOUT_REQUEST = "OAUTH_LOGOUT_REQUEST";
export const OAUTH_LOGOUT_SUCCESS = "OAUTH_LOGOUT_SUCCESS";
export const OAUTH_LOGOUT_FAILURE = "OAUTH_LOGOUT_FAILURE";

const successPayload = (action, state, res) => {
  return getJSON(res).then(json => json);
};

const getFormBody = code => {
  const formData = new FormData();
  formData.append("grant_type", GRANT_TYPE);
  formData.append("code", code);
  formData.append("redirect_uri", REDIRECT_URL);
  formData.append("client_id", CLIENT_ID);
  formData.append("scope", SCOPE);
  return new URLSearchParams(formData);
};

const getRefreshFormBody = (code, rights) => {
  const formData = new FormData();
  formData.append("grant_type", "refresh_token");
  formData.append("refresh_token", code);
  formData.append("client_id", CLIENT_ID);
  formData.append("scope", rights);
  return new URLSearchParams(formData);
};

const getLogoutFormBody = userName => {
  const formData = new FormData();
  formData.append("user_id", userName);
  return new URLSearchParams(formData);
};

export const retrieveToken = code => ({
  [RSAA]: {
    endpoint: `${OAUTH_SERVER}/token`,
    method: "POST",
    headers: { Authorization: "Basic " + btoa(`${CLIENT_ID}:${CLIENT_SECRET}`) },
    body: getFormBody(code),
    skipAuth: true,
    types: [
      OAUTH_TOKEN_REQUEST,
      {
        type: OAUTH_TOKEN_SUCCESS,
        payload: successPayload,
      },
      OAUTH_TOKEN_FAILURE,
    ],
  },
});

export const refreshTokenAction = (code, rights) => ({
  [RSAA]: {
    endpoint: `${OAUTH_SERVER}/token`,
    method: "POST",
    headers: { Authorization: "Basic " + btoa(`${CLIENT_ID}:${CLIENT_SECRET}`) },
    body: getRefreshFormBody(code, rights),
    skipAuth: true,
    types: [
      OAUTH_TOKEN_REQUEST,
      {
        type: OAUTH_REFRESH_SUCCESS,
        payload: successPayload,
      },
      OAUTH_TOKEN_REFRESH_FAILURE,
    ],
  },
});

export const logout = userName => ({
  [RSAA]: {
    endpoint: `${OAUTH_SERVER}/logout`,
    method: "POST",
    body: getLogoutFormBody(userName),
    types: [OAUTH_LOGOUT_REQUEST, OAUTH_LOGOUT_SUCCESS, OAUTH_LOGOUT_FAILURE],
  },
});

export const resetLogoutError = () => ({
  type: OAUTH_LOGOUT_FAILURE,
  message: "No Message",
});

export const setRandomState = authState => ({
  type: OAUTH_SET_RANDOM_STATE,
  authState,
});

export const setOAuthData = (authData, username, clientId, rights) => ({
  type: OAUTH_SET_DATA,
  authData,
  username,
  clientId,
  rights,
});

export const setNotificationPermission = notificationPermission => ({
  type: OAUTH_SET_NOTIFICATION_PERMISSION,
  notificationPermission,
});
